module.exports = __webpack_public_path__ + "img/thumb_aula44.6d585884.jpg";